import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { LocalCurrencyNote } from './LocalCurrencyNote';
import { useCountdown } from '../hooks/useCountdown';
import { markCheckoutStarted } from '../hooks/useExitIntent';
import { PRODUCTS } from './MetaPixel';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard, CheckCircle2, Mail, Instagram, Facebook } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'LM',
    name: 'Luciana M.',
    location: 'Chile',
    product: 'Compró la Biblioteca',
    text: 'Tenía todo esparcido. Ahora tengo la biblioteca completa. Mis sesiones son completamente diferentes.',
    bg: 'bg-brandViolet'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'Colombia',
    product: 'Compró la Biblioteca',
    text: 'Lo que buscaba en 10 lugares diferentes, acá lo tengo en UNO. Cambió mi forma de trabajar.',
    bg: 'bg-brandIndigo-electric'
  }, {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'México',
    product: 'Compró la Biblioteca',
    text: 'Imprimí todo. Tengo los módulos en mi escritorio. En cada sesión sé exactamente qué hacer.',
    bg: 'bg-brandViolet'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Uruguay',
    product: 'Compró la Biblioteca',
    text: 'Pasé años juntando información. Esta biblioteca ES lo que siempre necesité en un paquete.',
    bg: 'bg-brandIndigo-electric'
  }];
  return <Section className="bg-bg-alt" data-id="element-161" data-mp="3gbtzmx1un74q">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-162" data-mp="3gaino9y92t2j">
        <h2 className="font-display font-extrabold uppercase md:text-[40px] text-txt-primary mb-3 md:mb-4 text-[24px]" data-id="element-163" data-mp="3ubbfuo12xc2h">
          Lo que dicen{' '}
          <span className="text-brandViolet" data-id="element-164" data-mp="3pdjp3xc67vzv">los que ya dominan</span>
        </h2>
        <div className="inline-flex items-center gap-2 bg-bg-card border border-line rounded-full px-4 py-2" data-id="element-165" data-mp="1zwipp4iytdhx">
          <div className="flex text-gold" data-id="element-166" data-mp="1uz8ypkfxgtrz">
            {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-current" data-id="element-167" data-mp="3v106lutirnv3" data-mpi={j} />)}
          </div>
          <span className="font-sans font-bold text-txt-primary text-sm" data-id="element-168" data-mp="3u5v1316v0zr">
            4.9/5
          </span>
          <span className="font-sans text-txt-muted text-xs md:text-sm" data-id="element-169" data-mp="7w0rnu86cq77">
            · +300 terapeutas de Latinoamérica
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-170" data-mp="csr84inw5nt5">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-171" data-mp="hs43xswqq57v" data-mpi={i}>
            <div className="bg-bg-card p-4 md:p-5 rounded-[16px] border border-line h-full flex flex-col" data-id="element-172" data-mp="mrqhk3ghdnh7">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-173" data-mp="rk9vx2mzsmn2">
                <div className={`w-9 h-9 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-xs shrink-0`} data-id="element-174" data-mp="vlldqlzmk3kp">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-175" data-mp="15iq2mtkuud57">
                  <div className="flex text-gold mb-0.5" data-id="element-176" data-mp="15jsqstqsm1hf">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-177" data-mp="1fp11uwtyjeaz" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[13px] leading-tight" data-id="element-178" data-mp="1ams7bw1fs46r">
                    {t.name}
                  </p>
                  <p className="text-[11px] font-sans text-txt-muted" data-id="element-179" data-mp="11nyemgr87xyh">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[13px] md:text-[14px] leading-[1.5] italic mb-2.5" data-id="element-180" data-mp="1yg201in975th">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandViolet mt-auto" data-id="element-181" data-mp="1oncpcpzj1vz7">
                {t.product}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-bg-base" data-id="element-182" data-mp="2cdqikjtum0vd">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-183" data-mp="2ccnsge4co2gi">
        <div className="bg-bg-card border border-[rgba(34,197,94,0.2)] rounded-[20px] p-6 md:p-10 relative overflow-hidden" data-id="element-184" data-mp="1wvpaawf64h2n">
          <ShieldCheck size={70} className="mx-auto text-success mb-5 md:mb-6 relative z-10" data-id="element-185" data-mp="21v25q5k3uwgu" />
          <h2 className="font-display font-extrabold uppercase text-[22px] md:text-[38px] leading-[1.2] text-txt-primary mb-6 md:mb-8 relative z-10" data-id="element-186" data-mp="1nvsr3abjsaez">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body space-y-3 md:space-y-4 mb-6 md:mb-8 relative z-10" data-id="element-187" data-mp="2fn8cj11dbr3m">
            <p data-id="element-188" data-mp="26tv9355oh73a">Accedes a TODO. Lo imprimes. Lo usas en tus sesiones.</p>
            <p className="font-sans font-bold text-lg md:text-xl text-txt-primary leading-snug py-2" data-id="element-189" data-mp="26tmyxl0xwfvs">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-190" data-mp="2ykszg2kkofll" />
              devolución del 100%.
            </p>
            <p data-id="element-191" data-mp="33brkffgia1v6">Sin formularios. Sin complicaciones. Sin vueltas.</p>
          </div>
          <p className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-txt-muted relative z-10" data-id="element-192" data-mp="33dvtscx6bt2u">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Es para alguien que recién empieza o que ya estudia?',
    a: 'Para quien YA CONOCE el tema pero tiene todo disperso. Si ya estudiaste chakras en diferentes lugares, esto es lo que faltaba para dominar realmente. No es una introducción básica, es el siguiente nivel.'
  }, {
    q: '¿En qué moneda pago?',
    a: 'El precio está en USD pero se convierte automáticamente a tu moneda local al finalizar. Podés pagar con tarjeta de crédito, débito o métodos de pago locales según tu país.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de pagar recibís acceso a los 11 recursos en PDF. En menos de 5 minutos podés empezar a descargar. No hay envío, es 100% digital.'
  }, {
    q: '¿Necesito alguna certificación previa para aprovecharlo?',
    a: 'No. Solo es recomendable tener algún contacto previo con chakras o prácticas holísticas. Este programa es para quienes quieren profundizar y organizar lo que ya saben.'
  }, {
    q: '¿Funciona si trabajo de forma independiente y no en un centro?',
    a: 'Perfectamente. Está pensado para terapeutas independientes, en centros holísticos, online o presencial. Los materiales se adaptan a cualquier contexto.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días desde la compra. Si no es lo que esperabas, devolvemos el 100% sin preguntas ni formularios. Tasa de devoluciones: menos del 2%.'
  }, {
    q: '¿Puedo usar la biblioteca con mis consultantes?',
    a: 'Sí. Los conocimientos, técnicas, meditaciones y rituales están diseñados para usar en tus sesiones con consultantes.'
  }, {
    q: '¿Por cuánto tiempo tengo acceso?',
    a: 'Acceso de por vida. Una vez que compres, el material es tuyo para siempre. Podés descargar, guardar e imprimir cuantas veces quieras.'
  }, {
    q: '¿Qué formato exacto es?',
    a: '100% PDF. Imprimible, descargable y compatible con cualquier dispositivo (computadora, tablet, celular).'
  }, {
    q: '¿Hay actualizaciones incluidas?',
    a: 'Sí. Cualquier actualización o material adicional que agregue a la biblioteca lo recibirás automáticamente sin costo extra.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-bg-alt" data-id="element-193" data-mp="2u95omfc6fcut">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-194" data-mp="2uaguckp6muok">
        <h2 className="font-display font-extrabold uppercase text-[24px] md:text-[38px] leading-[1.2] text-txt-primary text-center mb-8 md:mb-10" data-id="element-195" data-mp="2pifiv0zu97zl">
          ❓ LO QUE MÁS NOS <span className="text-brandViolet" data-id="element-196" data-mp="2lehkisic817l">PREGUNTAN</span>
        </h2>
        <div className="space-y-3 md:space-y-4" data-id="element-197" data-mp="2gisec6btbm2b">
          {faqs.map((faq, i) => <div key={i} className={`bg-bg-card border border-line rounded-[16px] overflow-hidden transition-colors ${openIndex === i ? 'bg-bg-highlight' : ''}`} data-id="element-198" data-mp="2bixsih6w9mo4" data-mpi={i}>
              <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex justify-between items-center gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-199" data-mp="26lntc9tpdwn3">
                <span className="font-sans font-bold text-[14px] md:text-[16px] text-txt-primary" data-id="element-200" data-mp="3lfbbpluma3ul">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="text-brandViolet shrink-0" size={20} data-id="element-201" data-mp="3qckwgo729rc3" /> : <ChevronDown className="text-txt-muted shrink-0" size={20} data-id="element-202" data-mp="3bp9jqiz581ae" />}
              </button>
              {openIndex === i && <div className="px-5 pb-5 md:px-6 md:pb-5 font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body border-t border-line pt-4" data-id="element-203" data-mp="3gh1dt3hicp5a">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: 'Años buscando en internet y cursos sueltos',
    costo: 'Conocimiento disperso y sin sistema'
  }, {
    sin: '3 horas buscando cada fin de semana',
    costo: '156 horas perdidas por año (4 semanas de trabajo)'
  }, {
    sin: 'No tener TODO en un lugar',
    costo: 'Sesiones sin estructura real'
  }, {
    sin: 'Improvisación en cada consulta',
    costo: 'Resultados inconsistentes'
  }, {
    sin: 'No dominar realmente el sistema',
    costo: 'Nunca llegar al siguiente nivel'
  }, {
    sin: 'Seguir comprando cursos por separado',
    costo: 'Dinero y tiempo desperdiciados'
  }];
  return <Section className="bg-bg-base" data-id="element-204" data-mp="2x0gavjo83wwc">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-205" data-mp="2t20ptlbpcylk">
        <h2 className="font-display font-extrabold uppercase text-[26px] md:text-[40px] leading-[1.2] text-center text-txt-primary mb-8 md:mb-12" data-id="element-206" data-mp="2sz4u83nbum0a">
          ⚖️ ¿CUÁNTO CUESTA
          <br data-id="element-207" data-mp="31uuci3thb09g" />
          <span className="text-brandViolet" data-id="element-208" data-mp="31ub0t4uf983v">NO TENERLO?</span>
        </h2>

        <div className="bg-bg-card rounded-[16px] md:rounded-[20px] overflow-hidden border border-line mb-8 md:mb-10" data-id="element-209" data-mp="3grlbibz8q9yj">
          <div className="grid grid-cols-2 bg-bg-highlight p-3 md:p-5" data-id="element-210" data-mp="3btjs1pxwk8mj">
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-muted" data-id="element-211" data-mp="3dysdx4kzi5g5">
              Sin la Biblioteca
            </div>
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-primary pl-3 md:pl-5 border-l border-line" data-id="element-212" data-mp="3957f5abkh7fw">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-line" data-id="element-213" data-mp="3086sp9825jf3">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-5 gap-3 md:gap-5 items-center" data-id="element-214" data-mp="pxiihqg4ufi" data-mpi={i}>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-txt-muted pr-2" data-id="element-215" data-mp="3rythirsmvqzb">
                  {row.sin}
                </div>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-danger font-medium pl-3 md:pl-5 border-l border-line flex items-start gap-1.5" data-id="element-216" data-mp="3ixd5kfm67gsz">
                  <span aria-hidden="true" data-id="element-217" data-mp="27hya5g9m0wzz">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <p className="font-sans font-bold text-[14px] md:text-xl text-center text-txt-primary w-full mx-auto" data-id="element-218" data-mp="n0p4rzwim7jp">
          Tu próxima sesión puede ser diferente...
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds,
    isUrgent
  } = useCountdown();
  const accent = isUrgent ? 'text-danger' : 'text-brandViolet';
  return <Section className="bg-bg-alt border-t border-line pt-12 md:pt-16 pb-20 md:pb-24" data-id="element-219" data-mp="15qx2u3lcy7t1">
      <FadeIn className="max-w-[700px] mx-auto text-center" data-id="element-220" data-mp="1aop4vqfpvaay">
        {/* Urgency intro copy */}
        <div className="mb-8 md:mb-10" data-id="element-221" data-mp="1fol0b1acltew">
          <p className="font-display font-extrabold uppercase text-[20px] md:text-[32px] leading-[1.3] text-txt-primary" data-id="element-222" data-mp="1fotbmoqtoqnz">
            Puedes seguir buscando información en{' '}
            <span className="text-brandViolet" style={{
            textShadow: '0 0 12px rgba(139,92,246,0.28)'
          }} data-id="element-223" data-mp="3hgpxosam9ix0">
              10 lugares
            </span>
            ,
            <br data-id="element-224" data-mp="sm9n5c57zj8f" />o tener TODO en ORGANIZADO y LISTO desde hoy.
          </p>
          <p className="font-display font-black uppercase text-[26px] md:text-[38px] leading-[1.2] text-brandViolet animate-pulse mt-3" data-id="element-225" data-mp="nnom5ai58vix">
            Tú decides.
          </p>
        </div>

        <div className="mb-10 md:mb-12" data-id="element-226" data-mp="11l4tqpc6evc9">
          <div className="inline-flex items-center gap-1.5 bg-danger/15 border border-danger/40 text-danger font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 rounded-full mb-3 animate-pulse" data-id="element-227" data-mp="xlmi6k68vwm3">
            <span className="w-1.5 h-1.5 rounded-full bg-danger animate-pulse" data-id="element-228" data-mp="16m167ralfpta"></span>
            🚨 ÚLTIMA OPORTUNIDAD
          </div>
          <h3 className={`font-sans font-bold uppercase tracking-[1.5px] text-[11px] mb-3 md:mb-4 ${accent}`} data-id="element-229" data-mp="1gcdplg6o9cxu">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className={`inline-flex items-center gap-2 md:gap-3 bg-bg-card border-2 px-5 py-3 md:px-6 md:py-4 rounded-[14px] transition-colors ${isUrgent ? 'border-danger shadow-[0_0_30px_rgba(239,68,68,0.45)] animate-red-glow' : 'border-brandViolet shadow-[0_0_30px_rgba(139,92,246,0.4)] animate-glow-button'}`} data-id="element-230" data-mp="1ucogukbw8tjj">
            {[hours, minutes, seconds].map((unit, i) => <React.Fragment key={i} data-id="element-231" data-mp="1zyp2brgr56d1" data-mpi={i}>
                {i > 0 && <span className={`font-display font-black text-[30px] md:text-[40px] leading-none ${accent}`} data-id="element-232" data-mp="1zxw4jfzrtr71">
                    :
                  </span>}
                <span className={`font-display font-black text-[30px] md:text-[40px] leading-none ${accent}`} data-id="element-233" data-mp="1q82oo2slipwz">
                  {unit.toString().padStart(2, '0')}
                </span>
              </React.Fragment>)}
          </div>
          <p className="font-sans font-bold text-[11px] md:text-[13px] text-danger mt-3 uppercase tracking-[1.5px]" data-id="element-234" data-mp="1gbra165j9nzd">
            Después sube. No vuelve a este precio.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10 md:mb-12" data-id="element-235" data-mp="17a07ga6ahx9q">
          <div className="bg-bg-card rounded-[22px] p-5 md:p-8 border-2 border-brandViolet text-left shadow-[0_0_50px_rgba(139,92,246,0.2),inset_0_0_30px_rgba(139,92,246,0.03)]" data-id="element-236" data-mp="1c931kzkqej2x">
            <h4 className="font-display font-extrabold uppercase text-[16px] md:text-[22px] leading-[1.25] text-txt-primary text-center" data-id="element-237" data-mp="z8sigfl8tiub">
              BIBLIOTECA MAESTRA DEL CÓDIGO DE LOS{' '}
              <span className="text-brandViolet" data-id="element-238" data-mp="qggwb5x5whk5">CHAKRAS™</span>
            </h4>
            <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted text-center mt-2 mb-3 md:mb-4" data-id="element-239" data-mp="qee5wks3kmew">
              Lo que incluye:
            </p>

            <ul className="space-y-2 md:space-y-2.5" data-id="element-240" data-mp="ggztqxd7ijse">
              {['6 Módulos principales — 475 páginas organizadas', '5 Bonos listos para imprimir', 'TODO lo que necesitas dominar en un solo acceso', 'Acceso inmediato y para siempre'].map(item => <li key={item} className="flex items-start gap-2" data-id="element-241" data-mp="25wz9ixbbz7h0">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-242" data-mp="25v4tnxex25js" />
                  <span className="font-sans text-[12.5px] md:text-[15px] leading-[1.45] text-txt-body" data-id="element-243" data-mp="21wf8vjrjtlq4">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-4 md:mt-5 pt-3 md:pt-4 border-t border-line text-center" data-id="element-244" data-mp="3oqsiecxsh7ax">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted" data-id="element-245" data-mp="3tkdd9w435l5w">
                Valor original
              </p>
              <p className="font-display font-black text-[20px] md:text-[26px] leading-none line-through text-danger mt-1" data-id="element-246" data-mp="30uy2n7gc1uai">
                USD $79
              </p>
            </div>

            <div className="mt-3 md:mt-4 rounded-[16px] border border-brandViolet/30 bg-bg-alt px-4 py-3.5 md:py-5 text-center" data-id="element-247" data-mp="39vcn64lh35cy">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandViolet" data-id="element-248" data-mp="3ev8q00ifoqqx">
                Acceso completo hoy por
              </p>
              <p className="font-display font-black text-[40px] md:text-[54px] leading-none text-brandViolet mt-1" data-id="element-249" data-mp="u3farfj1io2p">
                $19{' '}
                <span className="font-sans font-bold text-[14px] md:text-[18px] align-middle" data-id="element-250" data-mp="2q5ienr7y6pe4">
                  USD
                </span>
              </p>
              <p className="font-sans font-bold text-[11px] md:text-[13px] text-success mt-2" data-id="element-251" data-mp="305sr39m5rss8">
                76% de descuento — Solo en lanzamiento
              </p>
              <p className="font-sans text-[10.5px] md:text-[13px] text-txt-muted mt-1.5" data-id="element-252" data-mp="2v4d8rpbd80dj">
                Pago único · Incluye garantía de 7 días
              </p>
            </div>

            <LocalCurrencyNote className="mt-3 md:mt-4" data-id="element-253" data-mp="22jbuk6l91j7j" />

            <div className="mt-4 md:mt-5" data-id="element-254" data-mp="2h6op2kt1aza2">
              <CTAButton href={PRODUCTS.biblioteca.checkoutUrl} fullWidth trackingProduct="biblioteca" onClick={markCheckoutStarted} className="!py-3.5 md:!py-4 !text-[13.5px] md:!text-base" data-id="element-255" data-mp="2h8htdtg6d7ew">
                💜 QUIERO EL ACCESO A LA BIBLIOTECA COMPLETA 
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 font-sans text-[12px] md:text-[13px] text-txt-muted" data-id="element-256" data-mp="3vemmxvq116vb">
          <span className="flex items-center gap-2" data-id="element-257" data-mp="3zypc18reiux">
            <Lock size={14} data-id="element-258" data-mp="41jlfvaq29uw" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-259" data-mp="3mezif1203ky1">
            <Clock size={14} data-id="element-260" data-mp="3qf9riml3arh4" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-261" data-mp="3qfjfy5qhkqkp">
            <ShieldCheck size={14} data-id="element-262" data-mp="hz85x20vnezf" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-263" data-mp="mykrljg0ig0f">
            <CreditCard size={14} data-id="element-264" data-mp="mwgp95xrhp29" /> Tarjeta | Débito | Pago local en tu moneda
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-bg-base border-t border-line py-12 px-6" data-id="element-265" data-mp="dwjzt23jsm65">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-266" data-mp="2tohgi3d0jpm7">
        <div data-id="element-267" data-mp="2trdflv0lkkc8">
          <h2 className="font-display font-black text-base md:text-xl text-txt-primary mb-1 leading-snug" data-id="element-268" data-mp="2ynu5atng36rf">
            🔮 BIBLIOTECA MAESTRA DEL CÓDIGO DE LOS CHAKRAS™
          </h2>
          <p className="font-sans font-bold text-sm text-brandViolet" data-id="element-269" data-mp="3pbuh1euru4cv">
            by FRECUENCIA VITAL
          </p>
        </div>

        <p className="font-sans text-[13px] text-txt-muted max-w-md mx-auto" data-id="element-270" data-mp="3gcz99yc2wm7g">
          La biblioteca profesional número 1 para quienes estudian energía en
          Latinoamérica. Porque aprender disperso en 10 lugares es perder años.
          Aquí lo tienes TODO.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 font-sans text-[13px] text-txt-muted pt-4" data-id="element-271" data-mp="7xpe7a6lwh96">
          <a href="mailto:soportefrecuenciavital@gmail.com" className="inline-flex items-center gap-1.5 hover:text-txt-primary transition-colors" data-id="element-272" data-mp="35xk4po8rtea">
            <Mail size={14} aria-hidden="true" data-id="element-273" data-mp="3ubfokdo0bl17" />
            soportefrecuenciavital@gmail.com
          </a>
          <a href="https://www.instagram.com/frecuencia_vital_ok" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 hover:text-txt-primary transition-colors" data-id="element-274" data-mp="qwjs6gy8xdoa">
            <Instagram size={14} aria-hidden="true" data-id="element-275" data-mp="136sw58sefico" />
            @frecuencia_vital_ok
          </a>
          <a href="https://www.facebook.com/profile.php?id=61591817787711" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 hover:text-txt-primary transition-colors" data-id="element-276" data-mp="185vpvx2xi25c">
            <Facebook size={14} aria-hidden="true" data-id="element-277" data-mp="1h6k8l539oqok" />
            Frecuencia Vital
          </a>
        </div>

        <div className="pt-8 border-t border-line space-y-3" data-id="element-278" data-mp="1m5dhek7lztie">
          <p className="font-sans text-xs text-txt-faint" data-id="element-279" data-mp="1m3kcpagk3jd1">
            © 2024 Frecuencia Vital. Todos los derechos reservados. Precios en
            dólares (USD) · Cobro en tu moneda local.
          </p>
          <p className="space-x-4 font-sans text-xs text-txt-faint" data-id="element-280" data-mp="1vxjdo64w8x3e">
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-281" data-mp="20w4cc14hz8pq">
              Términos y condiciones
            </a>
            <span data-id="element-282" data-mp="24ts9latnxdks">·</span>
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-283" data-mp="34cibzs4slb3i">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};